const getPageAfterBulkAction = (pagination: Pagination | undefined, isData: boolean) => {
  if (pagination === undefined) {
    return 1
  }
  if (isData) {
    return pagination.page
  }
  return 1
}

export {
  getPageAfterBulkAction
}
